import { useEffect, useState } from "react";
import { fetchCoachPicture } from "../utils/fetchCoachPicture";

/**
 * Fetches a coach's profile picture by email.
 * Returns a blob object URL (cached), falling back to initials on error.
 *
 * @param {string | undefined} email
 * @returns {{ objectUrl: string | null, imgError: boolean, loading: boolean }}
 */
export function useCoachPicture(email) {
  const [objectUrl, setObjectUrl] = useState(null);
  const [imgError, setImgError] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!email) return;
    let cancelled = false;
    setLoading(true);
    setObjectUrl(null);
    setImgError(false);
    fetchCoachPicture(email)
      .then((url) => {
        if (!cancelled) setObjectUrl(url);
      })
      .catch(() => {
        if (!cancelled) setImgError(true);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [email]);

  return { objectUrl, imgError, setImgError, loading };
}
